import { createUseStyles } from 'react-jss'
import { lightGrey } from '../../../styles/const/colors'
import { transitionShort } from '../../../styles/const/common'

const useStyles = createUseStyles(theme => ({
  radio: {
    position: 'relative'
  },
  radioInput: {
    width: 0,
    height: 0,
    opacity: 0,
    position: 'absolute'
  },
  radioLabel: {
    display: 'block',
    minWidth: 24,
    minHeight: 24,
    cursor: ({ disabled }) => (disabled ? 'auto' : 'pointer'),
    '&:before': {
      content: '""',
      position: 'absolute',
      top: -13,
      left: -13,
      width: 'calc(100% + 26px)',
      height: 'calc(100% + 26px)'
    }
  },
  radioTitle: {
    padding: '3px 0 2px 33px',
    fontSize: ({ smallFontSize }) => (smallFontSize ? 14 : 16),
    fontWeight: 700,
    position: 'relative',
    color: ({ disabled }) => (disabled ? lightGrey : 'inherit'),

    '&:hover&:before': {
      backgroundColor: theme.brandPrimaryLight
    },
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      cursor: ({ disabled }) => (disabled ? 'auto' : 'pointer'),
      boxSizing: 'border-box'
    },
    '&:before': {
      transition: transitionShort,
      border: {
        style: 'solid',
        width: 3,
        radius: '50%',
        color: lightGrey
      },
      top: 0,
      left: 0,
      width: 24,
      height: 24
    },
    '&:after': {
      top: 6,
      left: 6,
      width: 12,
      height: 12,
      borderRadius: '50%',
      backgroundColor: ({ checked }) => (checked ? theme.brandPrimary : 'transparent'),
      transition: transitionShort
    }
  }
}))

export default useStyles
